import React from 'react';

interface WindowFooterProps {
  children: React.ReactNode;
}

const WindowFooter: React.FC<WindowFooterProps> = ({ children }) => {
  return <div className="window-footer">{children}</div>;
};

export default WindowFooter;
